import React from 'react';
import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import starFilledTokens from '@amzn/meridian-tokens/base/icon/star-filled';
import { AchievementCardProps } from '../model';

const AchievementCard: React.FC<AchievementCardProps> = ({ siteName }) => {
  return (
    <Box type="outline" spacingInset="400">
      <Column spacing="300">
        <Heading type="h300" level={4} className="leaderboard-title">
          Achievement Pop-up Card
        </Heading>
        <Text type="b200" color="secondary">
          Displayed to the best site of last week
        </Text>
        <Box spacingInset="400" className="achievement-card__inner">
          <Column spacing="200">
            <Heading type="h300" level={4}>
              <span>Congratulations {siteName}!</span>
            </Heading>
            <Text type="b200">
              You are the best performing site last week. Shift plans were generated ahead of schedule every day.
            </Text>
            <Row spacing="200" alignmentVertical="center">
              <span className="leaderboard-icon"><Icon tokens={starFilledTokens} /></span>
              <Text type="b200">Best Site of Last Week</Text>
            </Row>
          </Column>
        </Box>
      </Column>
    </Box>
  );
};

export default AchievementCard;
